/** Native newsletter POST and Shopify privacy preferences; no simulated success. */
class AvlFooter extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.desktop = matchMedia('(min-width: 750px)');
    this.accordions = [...this.querySelectorAll('[data-footer-accordion]')];
    this.updateAccordions = () => {
      for (const details of this.accordions) {
        details.open = this.desktop.matches;
        const summary = details.querySelector('summary');
        if (this.desktop.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      }
    };
    this.updateAccordions();
    this.desktop.addEventListener('change', this.updateAccordions, { signal });
    this.addEventListener('click', event => {
      const summary = event.target.closest('[data-footer-accordion] > summary');
      if (summary && this.desktop.matches) event.preventDefault();
      const cookieButton = event.target.closest('[data-cookie-preferences]');
      if (cookieButton) this.openPreferences(cookieButton);
    }, { signal });
    const form = this.querySelector('.avlf-form');
    if (form) {
      const email = form.querySelector('[type=email]');
      const consent = form.querySelector('[type=checkbox]');
      email?.addEventListener('input', () => email.setCustomValidity(''), { signal });
      email?.addEventListener('invalid', () => email.setCustomValidity(email.validity.valueMissing ? window.avlT_('shell.footer.email_missing') : window.avlT_('shell.footer.email_invalid')), { signal });
      consent?.addEventListener('change', () => consent.setCustomValidity(''), { signal });
      consent?.addEventListener('invalid', () => consent.setCustomValidity(window.avlT_('shell.footer.consent_missing')), { signal });
      email?.addEventListener('keydown', event => {
        if (this.submitting && event.key === 'Enter') event.preventDefault();
      }, { signal });
      form.addEventListener('submit', () => {
        // The disabled button/Enter guard stop repeated customer actions. Do not
        // cancel a provider-triggered resubmission after Shopify's captcha.
        if (this.submitting) return;
        if (!form.checkValidity()) return;
        this.submitting = true;
        const button = form.querySelector('[data-newsletter-submit]');
        const label = form.querySelector('[data-newsletter-label]');
        const status = form.querySelector('[data-newsletter-status]');
        if (!button || !label) return;
        const original = label.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = window.avlT_('shell.footer.sending');
        // Shopify's native POST and captcha may navigate or wait for a challenge.
        // A delayed response never becomes a success message or an automatic retry.
        this.resetSubmission = () => {
          this.submitting = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = original;
        };
        clearTimeout(this.submitTimer);
        this.submitTimer = setTimeout(() => {
          this.resetSubmission();
          status.textContent = window.avlT_('shell.footer.no_response');
        }, 20000);
      }, { signal });
    }
    window.addEventListener('pageshow', () => this.resetSubmission?.(), { signal });
    const result = this.querySelector('[data-footer-result]');
    if (result && window.location.hash.includes('AvlFooterNewsletter')) result.focus({ preventScroll: true });
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.abort = null;
    clearTimeout(this.submitTimer);
  }
  async openPreferences(button) {
    if (button.disabled) return;
    const status = this.querySelector('[data-cookie-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      if (!window.privacyBanner?.showPreferences) {
        if (!document.querySelector('script[src*="/privacy-banner/storefront-banner.js"]')) {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.async = true;
          document.head.append(script);
        }
        for (let attempt = 0; attempt < 30 && !window.privacyBanner?.showPreferences; attempt++) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
      if (!window.privacyBanner?.showPreferences) throw new Error('Privacy provider unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      status.textContent = window.avlT_('shell.footer.cookie_failed');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('avl-footer')) customElements.define('avl-footer', AvlFooter);

